// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xn-1";
export var printerIcon = "_xn-0";